import React, { useState } from "react";
import { DatePicker, TimePicker } from "antd";
import { DateTimePickerHeaderIcon } from "../../../common/icons";
import { useTranslation } from "react-i18next";
import "./dateAndTimeSlotPicker.css";

const DateAndTimeSlotPicker = ({ timeSlot, handlers, readOnly }) => {
	const { t } = useTranslation();

	return (
		<div className="timeslot_container">
			<div className="timeslot_container_header">
				<DateTimePickerHeaderIcon width={20} height={20} />
				<div className="timeslot_container_header_title">
					{readOnly ? (
						<>{t("internship_selectStudent_timeSlotPicker_step3_heading")}:</>
					) : (
						<>{t("internship_selectStudent_timeSlotPicker_step2_heading")}</>
					)}
				</div>
			</div>
			<div className="hr"></div>
			{/* <hr /> */}
			{readOnly ? (
				<table className="timeslot_container_table_readOnly">
					<tbody>
						{timeSlot.date1.dateString ? (
							<tr>
								<td>{timeSlot.date1.dateString}</td>
								<td>
									{timeSlot.date1time1.startTimeString &&
									timeSlot.date1time1.endTimeString ? (
										<>
											{`${timeSlot.date1time1.startTimeString} ~ ${timeSlot.date1time1.endTimeString}`}
										</>
									) : null}
								</td>
								<td>
									{timeSlot.date1time2.startTimeString &&
									timeSlot.date1time2.endTimeString ? (
										<>
											{`${timeSlot.date1time2.startTimeString} ~ ${timeSlot.date1time2.endTimeString}`}
										</>
									) : null}
								</td>
								<td>
									{timeSlot.date1time3.startTimeString &&
									timeSlot.date1time3.endTimeString ? (
										<>
											{`${timeSlot.date1time3.startTimeString} ~ ${timeSlot.date1time3.endTimeString}`}
										</>
									) : null}
								</td>
							</tr>
						) : null}
						{timeSlot.date2.dateString ? (
							<tr>
								<td>{timeSlot.date2.dateString}</td>
								{timeSlot.date2time1.startTimeString &&
								timeSlot.date2time1.endTimeString ? (
									<td>
										{`${timeSlot.date2time1.startTimeString} ~ ${timeSlot.date2time1.endTimeString}`}
									</td>
								) : null}
								{timeSlot.date2time2.startTimeString &&
								timeSlot.date2time2.endTimeString ? (
									<td>
										{`${timeSlot.date2time2.startTimeString} ~ ${timeSlot.date2time2.endTimeString}`}
									</td>
								) : null}
								{timeSlot.date2time3.startTimeString &&
								timeSlot.date2time3.endTimeString ? (
									<td>
										{`${timeSlot.date2time3.startTimeString} ~ ${timeSlot.date2time3.endTimeString}`}
									</td>
								) : null}
							</tr>
						) : null}
						{timeSlot.date3.dateString ? (
							<tr>
								<td>{timeSlot.date3.dateString}</td>
								{timeSlot.date3time1.startTimeString &&
								timeSlot.date3time1.endTimeString ? (
									<td>
										{`${timeSlot.date3time1.startTimeString} ~ ${timeSlot.date3time1.endTimeString}`}
									</td>
								) : null}
								{timeSlot.date3time2.startTimeString &&
								timeSlot.date3time2.endTimeString ? (
									<td>
										{`${timeSlot.date3time2.startTimeString} ~ ${timeSlot.date3time2.endTimeString}`}
									</td>
								) : null}
								{timeSlot.date3time3.startTimeString &&
								timeSlot.date3time3.endTimeString ? (
									<td>
										{`${timeSlot.date3time3.startTimeString} ~ ${timeSlot.date3time3.endTimeString}`}
									</td>
								) : null}
							</tr>
						) : null}
					</tbody>
				</table>
			) : (
				<table className="timeslot_container_table">
					<thead>
						<tr>
							<td>
								Date
								{/* {!readOnly && (
									<span className="timeSlot_tableHeader_requiredMark">*</span>
								)} */}
							</td>
							<td>
								Time 1
								{/* {!readOnly && (
									<span className="timeSlot_tableHeader_requiredMark">*</span>
								)} */}
							</td>
							<td>Time 2</td>
							<td>Time 3</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<DatePicker
									format="DD/MM/YYYY"
									onChange={handlers.onChangeDate1}
									//size="small"
									value={timeSlot.date1.date}
									className="interviewDatePicker"
								/>
								<span className="timeSlot_tableHeader_requiredMark">*</span>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate1Time1Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date1time1.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate1Time1End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date1time1.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
								<span className="timeSlot_tableHeader_requiredMark">*</span>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate1Time2Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date1time2.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate1Time2End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date1time2.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate1Time3Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date1time3.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate1Time3End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date1time3.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
							</td>
						</tr>
						<tr>
							<td>
								<DatePicker
									format="DD/MM/YYYY"
									onChange={handlers.onChangeDate2}
									//size="small"
									value={timeSlot.date2.date}
									className="interviewDatePicker"
								/>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate2Time1Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date2time1.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate2Time1End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date2time1.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate2Time2Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date2time2.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate2Time2End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date2time2.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate2Time3Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date2time3.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate2Time3End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date2time3.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
							</td>
						</tr>
						<tr>
							<td>
								<DatePicker
									format="DD/MM/YYYY"
									onChange={handlers.onChangeDate3}
									//size="small"
									value={timeSlot.date3.date}
									className="interviewDatePicker"
								/>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate3Time1Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date3time1.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate3Time1End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date3time1.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate3Time2Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date3time2.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate3Time2End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date3time2.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
							</td>
							<td>
								<TimePicker
									onChange={handlers.onChangeDate3Time3Start}
									use12Hours
									format="h:mm A"
									minuteStep={15}
									suffixIcon={null}
									//size="small"
									value={timeSlot.date3time3.startTime}
									className="interviewTimePicker"
									placeholder="Start time"
								/>{" "}
								~{" "}
								<TimePicker
									onChange={handlers.onChangeDate3Time3End}
									use12Hours
									format="h:mm A"
									suffixIcon={null}
									//size="small"
									value={timeSlot.date3time3.endTime}
									placeholder="End time"
									className="interviewTimePicker"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			)}
		</div>
	);
};

export default DateAndTimeSlotPicker;
